import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const DashboardLayout: React.FC = () => {
  return (
    <>
      <div
        className="flex h-screen transition-colors duration-300"
        style={{ backgroundColor: "var(--bg-primary)" }}
      >
        <Sidebar />
        <div
          className="flex-1 flex flex-col min-w-0"
          style={{ backgroundColor: "var(--bg-primary)" }}
        >
          <Header />
          <div className="flex-1 overflow-y-auto overflow-x-hidden min-w-0 relative">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
